import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d4b6ba0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-nav"
};
const _hoisted_2 = {
  class: "tk-nav-tabs"
};
const _hoisted_3 = {
  class: "tk-tabs"
};
const _hoisted_4 = {
  key: 0,
  class: "main"
};
const _hoisted_5 = {
  class: "loble"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "标题", -1));
const _hoisted_7 = {
  class: "input"
};
const _hoisted_8 = {
  class: "loble"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "内容", -1));
const _hoisted_10 = {
  class: "input"
};
const _hoisted_11 = {
  class: "loble"
};
const _hoisted_12 = {
  style: {
    "margin-top": "30px",
    "padding": "0 15px"
  }
};
const _hoisted_13 = {
  key: 1,
  class: "tk-notice-announcement"
};
const _hoisted_14 = {
  class: "tk-announcement"
};
const _hoisted_15 = {
  class: "tk-notice-title flex-between"
};
const _hoisted_16 = {
  class: "tk-title-l"
};
const _hoisted_17 = {
  class: "tk-notice-content"
};
const _hoisted_18 = {
  class: "tk-content"
};
const _hoisted_19 = {
  class: "image"
};
const _hoisted_20 = {
  class: "tk-tiems"
};
import nav_header from '@/components/nav_header.vue';
import { leave_comments, leave_list } from '@/util/http';
import axios from 'axios';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import { onBeforeMount } from 'vue';

import { reactive, ref, toRefs } from 'vue';
export default {
  __name: 'feedback',
  setup(__props) {
    let form = reactive({
      title: '',
      content: '',
      img: ''
    });
    let fileList = ref([]);
    let activeIndex = ref(0);
    let afterRead = file => {
      let forms = new FormData();
      forms.append("file", file.file); // 获取上传图片信息
      c(forms);
    };
    let c = forms => {
      // let url = 'https://www.389666a.com/api/upload_file'
      let url = 'https://api.6ctkapi.com/api/upload_file';
      let token = localStorage.getItem('Authorization');
      axios.post(url, forms, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: token
        }
      }).then(res => {
        let data = res.data.data[0];
        // fileList.value.push(data)
        form.img = data + ',';
      });
    };
    let comments = () => {
      if (form.img.length != 0) {
        let s = form.img;
        let c = s.substr(s, s.length - 1);
        form.img = c;
      }
      if (form.title == '' || form.content == '') {
        showToast('内容和标题不能为空');
      } else {
        leave_comments(form).then(res => {
          showToast(res.message);
          form.title = '';
          form.content = '';
          form.img = '';
          leaveList();
        });
      }
    };
    onBeforeMount(() => {
      leaveList();
    });
    let leave = reactive({
      leaceData: []
    });
    let leaveList = () => {
      leave_list().then(res => {
        console.log(res.data.data);
        let data = res.data.data;
        if (res.message == "用户未登录或已过期") {
          showToast(res.message);
          return false;
        }
        leave.leaceData.push(...data);
      });
    };
    let {
      leaceData
    } = toRefs(leave);
    let feedback = index => {
      activeIndex.value = index;
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_uploader = _resolveComponent("van-uploader");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_image = _resolveComponent("van-image");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "意见反馈"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("ul", null, [_createElementVNode("li", {
        class: _normalizeClass(_unref(activeIndex) == 0 ? 'active' : ''),
        onClick: _cache[0] || (_cache[0] = $event => _unref(feedback)(0))
      }, "意见反馈", 2), _createElementVNode("li", {
        class: _normalizeClass(_unref(activeIndex) == 1 ? 'active' : ''),
        onClick: _cache[1] || (_cache[1] = $event => _unref(feedback)(1))
      }, "我的回馈", 2)])])])]), _unref(activeIndex) == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).title = $event),
        type: "text",
        placeholder: "请输入标题...."
      }, null, 512), [[_vModelText, _unref(form).title]])])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: _unref(form).content,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).content = $event),
          rows: "4",
          "label-width": "0",
          autosize: "",
          label: "",
          type: "textarea",
          maxlength: "1000",
          placeholder: "请输入留言",
          "show-word-limit": ""
        }, null, 8, ["modelValue"])]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_van_uploader, {
        modelValue: _unref(fileList),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(fileList) ? fileList.value = $event : fileList = $event),
        "after-read": _unref(afterRead),
        multiple: "",
        accept: "image/png,image/jpeg"
      }, null, 8, ["modelValue", "after-read"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_button, {
        type: "primary",
        color: "#007539",
        block: "",
        onClick: _unref(comments)
      }, {
        default: _withCtx(() => [_createTextVNode("提交")]),
        _: 1
      }, 8, ["onClick"])])])) : _createCommentVNode("", true), _unref(activeIndex) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leaceData), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString(item.content), 1)]), _createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.img, (items, i) => {
          return _openBlock(), _createBlock(_component_van_image, {
            key: i,
            fit: "cover",
            src: items
          }, null, 8, ["src"]);
        }), 128))]), _createElementVNode("div", _hoisted_20, _toDisplayString(item.create_time), 1)]);
      }), 128))])])])) : _createCommentVNode("", true)], 64);
    };
  }
};